import {
  EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING,
  EMAIL_CREATION_FORM_INITIAL_VALUES,
} from '../../EmailCreationForm'

export const EMAIL_MASS_MAILING_FORM_INITIAL_VALUES = {
  ...EMAIL_CREATION_FORM_INITIAL_VALUES,
  [EMAIL_CREATION_FORM_FIELD_NAME_MASS_MAILING]: true,
}

// The backend rejects `copy_to_archive` together with `separate_messages`, so
// forms that copy the sent message into a profile never offer mass mailing.
export const EMAIL_COPY_TO_ARCHIVE_FORM_FIELDS_PROPS = {
  hideMassMailing: true,
}
